import { render, staticRenderFns } from "./row.vue?vue&type=template&id=1fb8b53a&scoped=true"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"
import style0 from "./row.vue?vue&type=style&index=0&id=1fb8b53a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb8b53a",
  null
  
)

export default component.exports